export const AVALABILITY_LAYOUT = {
  // PF
  sites: {
    "611acd7ed536b60023861446": {
      sections: [
        {
          id: "main",
          name: "Principal",
          environment: {
            homepage: {
              top: ["TOP1"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
            insidepage: {
              top: ["TOP1"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
            newsletter: {
              top: ["TOP1"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
          },
        },
        {
          id: "tgr",
          name: "The Grape Reporter",
          environment: {
            homepage: {
              top: ["TOP1", "TOP2"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
            insidepage: {
              top: ["TOP1", "TOP2"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
            newsletter: {
              top: ["TOP1", "TOP2"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
          },
        },
        {
          id: "agronotips",
          name: "Agronotips",
          environment: {
            homepage: {
              top: ["TOP1", "TOP2"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
            insidepage: {
              top: ["TOP1", "TOP2"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3"],
            },
            newsletter: {
              top: ["TOP1", "TOP2"],
              left: ["CONT0", "CONT1", "CONT2"],
              right: ["RGT1", "RGT2", "RGT3", "RGT4"],
            },
          },
        },
      ],
    },
  },
};
